import { atomWithStorage } from 'jotai/utils'
import { store } from '.'

export const REDIRECT_KEY = 'storedRedirect'

export type StoredRedirect = {
  path: string
  search: Record<string, unknown>
}

export const redirectAtom = atomWithStorage<StoredRedirect | null>(REDIRECT_KEY, null, undefined, {
  getOnInit: true,
})

export const getStoredRedirect = () => store.get(redirectAtom)

export const setStoredRedirect = (storedRedirect: StoredRedirect) =>
  store.set(redirectAtom, storedRedirect)

export const destroyStoredRedirect = () => {
  localStorage.removeItem(REDIRECT_KEY)
  store.set(redirectAtom, null)
}
